import { Feedback } from 'v2/core/entities/feedback';

interface FeedbackSourceIconProps {
  sourceV2: Feedback['sourceV2'];
}

const IMG_BOX_SIZE = 30;

const FeedbackSourceIcon = ({ sourceV2 }: FeedbackSourceIconProps) => {
  return (
    <img
      src={sourceV2?.logo}
      alt={sourceV2?.name}
      height="auto"
      width={IMG_BOX_SIZE}
    />
  );
};

export default FeedbackSourceIcon;
